const initCertificates = () => {
  const root = document.querySelector('[data-certificates]');

  if (!root) {
    return;
  }

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const items = root.querySelectorAll('[data-certificates-item]');

  items.forEach((item) => {
    const button = item.querySelector('[data-certificate-print]');
    const link = item.querySelector('[data-certificate-link]');

    button.addEventListener('click', async (evt) => {
      evt.preventDefault();

      const documentIframe = document.querySelector('#print-document');

      if (document.body.contains(documentIframe)) {
        document.body.removeChild(documentIframe);
      }

      const iframe = document.createElement('iframe');
      iframe.id = 'print-document';
      iframe.style.position = 'absolute';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = '0';
      iframe.style.visibility = 'hidden';
      iframe.src = link.href;

      document.body.appendChild(iframe);

      try {
        await new Promise((resolve, reject) => {
          iframe.onload = resolve;
          iframe.onerror = reject;
          iframe.src = link.href;
        });

        await delay(500);

        iframe.contentWindow.focus();
        iframe.contentWindow.print();

      } catch (error) {
        console.error('Ошибка при подготовке к печати:', error);
      }
    });
  });
};

export {initCertificates};
